<template>
  <div id="app" :class="{ 'plus-shell': layoutPlus }">
    <!-- [sc-48351 / task 3] Un'azienda PLUS lavora nella cornice di
         crmplus-web: sidebar a sinistra e barra sottile in alto. Le pagine,
         i banner e le modali sono gli stessi di START. -->
    <PlusSidebar
      v-if="layoutPlus"
      :collapsed="sidebarCompressa"
      :mobile-open="menuMobileAperto"
      @toggle="toggleSidebar"
      @close-mobile="menuMobileAperto = false"
    />
    <div
      v-if="layoutPlus && menuMobileAperto"
      class="plus-shell__overlay"
      @click="menuMobileAperto = false"
    ></div>

    <!-- In START non c'è: `display: contents` lo toglie dal layout. -->
    <div class="app-main">
      <PlusTopBar
        v-if="layoutPlus"
        :mobile-open="menuMobileAperto"
        @toggle-mobile="menuMobileAperto = !menuMobileAperto"
      />
      <TopBar v-else />
      <TrialBanner />
      <OnboardingHint />
      <TrialEndedModal />
      <OnboardingWelcome />
      <router-view />
      <div
        class="developed-container"
        v-if="$route.meta.showLogo"
        :class="{ 'login-layout': $route.path === '/login' }"
      >
        <span class="developed-label">Sviluppato da</span>
        <img
          src="@/assets/logo-liberotratto.png"
          alt="LiberoTratto"
          class="lt-logo"
        />
      </div>
    </div>
  </div>
</template>

<script>
import TopBar from "@/components/TopBar.vue"; // Percorso del componente TopBar
import TrialBanner from "@/components/TrialBanner.vue";
import OnboardingHint from "@/components/OnboardingHint.vue";
import TrialEndedModal from "@/components/TrialEndedModal.vue";
import OnboardingWelcome from "@/components/OnboardingWelcome.vue";
import PlusSidebar from "@/components/plus/PlusSidebar.vue";
import PlusTopBar from "@/components/plus/PlusTopBar.vue";
import { CLASSE_LAYOUT_PLUS, usaLayoutPlus } from "@/utilities/layoutPlus";

/** Dove si ricorda la sidebar compressa: una comodità di chi guarda. */
const CHIAVE_SIDEBAR = "plusSidebarCompressa";

function leggiSidebarCompressa() {
  try {
    return window.localStorage.getItem(CHIAVE_SIDEBAR) === "true";
  } catch {
    return false;
  }
}
// import { ref, watch } from "vue";
// import { useRoute } from "vue-router";

export default {
  name: "App",
  components: {
    TopBar,
    TrialBanner,
    OnboardingHint,
    TrialEndedModal,
    OnboardingWelcome,
    PlusSidebar,
    PlusTopBar,
  },
  data() {
    return {
      sidebarCompressa: leggiSidebarCompressa(),
      menuMobileAperto: false,
    };
  },
  computed: {
    /** [sc-48351 / task 3] Cornice PLUS: azienda PLUS, dentro il gestionale. */
    layoutPlus() {
      return usaLayoutPlus({
        plan: this.$store.getters["company/plan"],
        currentUser: this.$store.state.currentUser,
        route: this.$route,
      });
    },
  },
  watch: {
    // La classe va su <html>: le modali si disegnano fuori da #app, e senza
    // resterebbero vestite da START.
    layoutPlus: {
      immediate: true,
      handler(attivo) {
        document.documentElement.classList.toggle(CLASSE_LAYOUT_PLUS, attivo);
      },
    },
    "$route.path"() {
      this.menuMobileAperto = false;
    },
  },
  methods: {
    toggleSidebar() {
      this.sidebarCompressa = !this.sidebarCompressa;
      try {
        window.localStorage.setItem(
          CHIAVE_SIDEBAR,
          String(this.sidebarCompressa)
        );
      } catch {
        // Senza memoria del browser si ricomincia aperta: nessun danno.
      }
    },
  },
  // setup() {
  //   const route = useRoute();
  //   const breadcrumbs = ref([]);

  //   const generateBreadcrumbs = (currentRoute) => {
  //     return currentRoute.matched.map((matchedRoute) => ({
  //       name: matchedRoute.meta.breadcrumb || matchedRoute.name, // Usa il breadcrumb dal meta o il nome della rotta
  //       path: matchedRoute.path,
  //     }));
  //   };

  //   // Inizializza i breadcrumbs
  //   breadcrumbs.value = generateBreadcrumbs(route);

  //   // Osserva i cambiamenti della route e aggiorna i breadcrumbs
  //   watch(
  //     () => route.path,
  //     () => {
  //       breadcrumbs.value = generateBreadcrumbs(route);
  //     }
  //   );

  //   return { breadcrumbs };
  // },
};
</script>

<style src="@/css/App.css"></style>
<style src="@/css/plus/layout.css"></style>
<style src="@/css/plus/componenti.css"></style>
<style src="@/css/plus/pagine.css"></style>
